import protoRoot from "../proto-root";

const name = "deleteActivityLogEventRPCResponse";

function create() {
  const DeleteActivityLogEventRPCResponse = protoRoot.lookupType(
    "comm.DeleteActivityLogEventRPCResponse"
  );

  const request = DeleteActivityLogEventRPCResponse.create();
  return { payload: request, name };
}

export default {
  create,
  name
};

// message DeleteActivityLogEventRPCResponse {}
